import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, SnackbarService } from "@/services";
import { useBriefcaseStore } from "@/pinia/briefcase";
import { VignetteRoutes } from "@/types";
import { computed, getCurrentInstance, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { storeToRefs } from "pinia";
import BriefcaseFolderSelect from "@/components/selects/BriefcaseFolderSelect.vue";

interface Props {
  isOpen: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefcaseMassAddDialog',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ["dialog-changed"],
  setup(__props: any, { emit: emits }) {

const props = __props as { isOpen: boolean };



const isOpen = computed({
  get: () => props.isOpen,
  set: (value: boolean) => emits("dialog-changed", value),
});

const route = useRoute();

const instance = getCurrentInstance();

const briefcaseStore = useBriefcaseStore();
const { itemIds } = storeToRefs(briefcaseStore);
const currentFolderId = ref(briefcaseStore.meta.currentFolderId);
const updateCurrentFolderId = (folderId: number) => {
  if (folderId) {
    currentFolderId.value = folderId;
  }
};

const isLoading = ref(false);

const routeToDocTypeMapper: { [key: string]: string } = {
  [VignetteRoutes.SearchCongressional]: "congressional",
  [VignetteRoutes.SearchFederal]: "federal",
  [VignetteRoutes.SearchState]: "state",
  [VignetteRoutes.SearchUniversal]: "universal",
};
const addSearchResults = async () => {
  try {
    isLoading.value = true;
    const docType = routeToDocTypeMapper[route.name as string];
    const items = await ApiService.addAllSearchResults(
      currentFolderId.value,
      docType
    );
    itemIds.value.push(...items);
    ApiService.refreshBriefcase(true);

    SnackbarService.displaySnackbar(
      `Contents of search have been added to your folder.`,
      "primary"
    );

    instance?.proxy?.$forceUpdate();
    isOpen.value = false;
  } catch (e: unknown) {
    SnackbarService.displaySnackbar(e as string, "error");
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,emits, props, isOpen, route, instance, briefcaseStore, itemIds, currentFolderId, updateCurrentFolderId, isLoading, routeToDocTypeMapper, addSearchResults, NjBtn, BriefcaseFolderSelect }
}

})